// features/website/testSlice.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { testService } from "./testService";

// Thunk to fetch website by ID
export const fetchWebsiteById = createAsyncThunk(
  "tests/website/fetchById",
  async ({ websiteId, token }, thunkApi) => {
    try {
      return await testService.getWebsiteById(websiteId, token);
    } catch (error) {
      return thunkApi.rejectWithValue(error.response?.data || "Fetch error");
    }
  }
);


// Initial state
const initialState = {
  data: null,
  isLoading: false,
  isError: false,
  isSuccess: false,
  message: "",
};

// Slice
export const testSlice = createSlice({
  name: "tests",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWebsiteById.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchWebsiteById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = action.payload;
        state.message = "Website data fetched successfully.";
      })
      .addCase(fetchWebsiteById.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.error?.message || "Failed to fetch website data.";
      });
  },
});

export default testSlice.reducer;
